export const stringReplaceVariables = {
  businessCount: '{{businessCount}}',
  localWeeklyCostB2c: '{{localWeeklyCostB2c}}',
  localMonthlyCostB2c: '{{localMonthlyCostB2c}}',
  localMonthlyCostB2b: '{{localMonthlyCostB2b}}',
};
